import { useMemo } from 'react';
import { useMySubmission } from '@/modules/submissions/presentation/hooks/use-submissions';
import { fromGabaritoPayload } from '@/modules/gabarito/domain/entities/gabarito.entity';

/**
 * O gabarito enviado, já no formato da tela (número → letra). Gabarito,
 * Ranking, Prova Oficial e Diagnóstico partem dele.
 */
export function useMyGabarito() {
  const query = useMySubmission('gabarito');
  const answers = useMemo(
    () => (query.data ? fromGabaritoPayload(query.data.answers) : null),
    [query.data],
  );
  return { ...query, answers };
}
